import { useContext } from 'react'

import { WorkInFlightContext, type WorkInFlightValue } from './context'

export function useWorkInFlight(): WorkInFlightValue {
  return useContext(WorkInFlightContext)
}
